import { useEffect, useState } from "react";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { X, MapPin } from "lucide-react";
import SafeHtml from "@/components/site/SafeHtml";
import api from "@/lib/api";

export default function Projects() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Projects | Labpronics Technologies";
    api.get("/content/projects").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <Layout>
      <PageHero eyebrow="Deployments" title="Projects Across India" subtitle="A selection of surveillance, cybersecurity, coastal security, data-centre and smart-campus deployments delivered for government and enterprise clients." image="/generated/coastal.jpg" />
      <section className="py-20">
        <div className="container-lp grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <button onClick={() => setActive(p)} data-testid={`project-card-${i}`} className="group text-left bg-white border border-lp-border rounded-sm overflow-hidden hover:border-lp-cyan hover:shadow-[0_20px_40px_-24px_rgba(10,43,110,0.35)] transition-all h-full w-full">
                <div className="img-zoom h-48"><img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover" /></div>
                <div className="p-6">
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-600 tracking-wide uppercase text-lp-cyan"><MapPin size={13} /> {p.location}</span>
                  <h3 className="font-heading font-700 text-lp-blue text-lg mt-2 leading-snug">{p.title}</h3>
                  <p className="text-sm text-lp-muted mt-2 leading-relaxed line-clamp-2">{p.excerpt}</p>
                  <div className="flex flex-wrap gap-2 mt-4">{(p.tags || []).map((t) => <span key={t} className="text-[11px] font-600 border border-lp-border rounded-sm px-2 py-0.5 text-lp-muted">{t}</span>)}</div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[60] bg-lp-ink/60 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="project-modal">
          <div className="bg-white rounded-sm max-w-2xl w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="relative h-56"><img src={active.image} alt={active.title} className="w-full h-full object-cover" /><button onClick={() => setActive(null)} className="absolute top-4 right-4 bg-white rounded-sm p-1.5 text-lp-blue"><X size={20} /></button></div>
            <div className="p-8">
              <span className="inline-flex items-center gap-1.5 text-xs font-600 uppercase text-lp-cyan"><MapPin size={13} /> {active.location}</span>
              <h2 className="font-heading font-700 text-2xl text-lp-blue mt-2">{active.title}</h2>
              <SafeHtml className="prose-lp mt-4" html={active.content || `<p>${active.excerpt}</p>`} />
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
